import React, { ReactNode } from 'react';

import { useBooleanFlags } from '@/core/flags/flags.hooks';
import { Platform } from '@/core/settings/interfaces/Platform';
import { getPlatform } from '@/core/settings/utils';
import { Text } from '@/core/tamagoshi/Text/Text';
import {
  manoFulfillmentLabelFreeExpress,
  manoFulfillmentLabelFreeReturn,
  manoFulfillmentModalContent,
  manoFulfillmentModalContentReturn,
} from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/components/ManoFulfillment/translations';
import { MF_100_DAYS_FREE_RETURNS_FLAG } from '@/productDiscovery/ProductPage/constants';

export const pFormat = (chunks: ReactNode) => <Text tag="p">{chunks}</Text>;

export const FulfillmentHeader = () => {
  const [is100DaysReturn] = useBooleanFlags([MF_100_DAYS_FREE_RETURNS_FLAG]);

  const content = is100DaysReturn
    ? manoFulfillmentLabelFreeReturn.format({
        name: 'ManoMano',
      })
    : manoFulfillmentLabelFreeExpress;
  return <>{content}</>;
};

export const FulfillmentContent = () => {
  const [is100DaysReturn] = useBooleanFlags([MF_100_DAYS_FREE_RETURNS_FLAG]);

  const content = is100DaysReturn
    ? manoFulfillmentModalContentReturn.format({
        name: 'ManoMano',
        tag: pFormat,
      })
    : manoFulfillmentModalContent.format({
        name: 'ManoMano',
        tag: pFormat,
      });
  return <>{content}</>;
};

type FlagsByPlatform = Partial<Record<Platform, string>>;
export const useFlagsByPlatform = (flag: FlagsByPlatform) => {
  const platform = getPlatform();
  const [active] = useBooleanFlags([flag[platform] || '']); // a bit annoying, but we need to pass a string
  return active;
};
